export const carpayOrderRoute = (orderId = ':order_id') => `/carpay/orders/details/${orderId}`
